export default "__VITE_ASSET__6276741e__"